module.exports = __webpack_public_path__ + "static/img/盪鈴.b36da465.png";